import React from 'react';
import ExpandableUnit, { ExpandableUnitProps } from '../components/shared/expandableUnit';

const ExpandableUnitSection = (props: ExpandableUnitProps) => (
  <ExpandableUnit {...props} />
);

export default ExpandableUnitSection;
